import { CURRENT_SCHEMA_VERSION, type CvData } from '@/types/cv';

type CvLike = Partial<CvData> & { metadata?: Partial<CvData['metadata']> };

type Migration = (data: CvLike) => CvLike;

const migrations: Record<number, Migration> = {
  // future: 1: (data) => ({ ...data, ... }),
};

export function migrate(data: CvLike): CvData {
  let working = { ...data };
  let version = working.metadata?.schemaVersion ?? 0;

  while (version < CURRENT_SCHEMA_VERSION) {
    const migration = migrations[version];
    if (!migration) break;
    working = migration(working);
    version += 1;
  }

  return {
    ...working,
    metadata: {
      ...(working.metadata ?? {
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      }),
      schemaVersion: CURRENT_SCHEMA_VERSION,
    },
  } as CvData;
}
